import { BootstrapperBase } from './bootstrapper-base';

/**
 * Runs the initialize method of the boostrapper and returns its result.
 */
export function bootstrapperFactory(initializer: BootstrapperBase): () => Promise<void> {
  return () => initializer.initialize();
}
